import { render } from "./DescriptionHistoryWindow.vue?vue&type=template&id=8a13edf4"
import script from "./DescriptionHistoryWindow.vue?vue&type=script&lang=js"
export * from "./DescriptionHistoryWindow.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__